import { defineComponent as s, createBlock as i, openBlock as r, unref as p, withCtx as n, renderSlot as l, normalizeProps as a, guardReactiveProps as t, createElementBlock as m, createCommentVNode as u } from "vue";
import { RevModalBase as b } from "@ds/components/ModalBase";
const f = {
  key: 0,
  class: "pt-24"
}, B = /* @__PURE__ */ s({
  name: "RevDialog",
  __name: "Dialog",
  props: {
    name: {},
    title: { default: "" },
    closeButtonLabel: { default: () => {
    } },
    hasPadding: { type: Boolean, default: !0 },
    to: { default: "body" },
    defer: { type: Boolean, default: !1 },
    backdropZIndex: { default: () => {
    } },
    backgroundColor: { default: "mid" },
    disableCloseOnBackdropClick: { type: Boolean, default: !1 }
  },
  emits: ["open", "close"],
  setup(c) {
    return (e, d) => (r(), i(p(b), {
      "backdrop-background-color": "hi",
      "backdrop-z-index": e.backdropZIndex,
      "background-color": e.backgroundColor,
      class: "rounded-t-lg md:rounded-b-lg md:bottom-auto md:left-1/2 md:top-1/2 md:w-640 md:-translate-x-1/2 md:-translate-y-1/2",
      "close-button-label": e.closeButtonLabel,
      defer: e.defer,
      "disable-close-on-backdrop-click": e.disableCloseOnBackdropClick,
      "has-padding": e.hasPadding,
      name: e.name,
      title: e.title,
      to: e.to,
      onClose: d[0] || (d[0] = (o) => e.$emit("close", o)),
      onOpen: d[1] || (d[1] = (o) => e.$emit("open"))
    }, {
      body: n(({ close: o }) => [
        l(e.$slots, "body", a(t({ close: o }))),
        e.$slots.footer ? (r(), m("div", f, [
          l(e.$slots, "footer", a(t({ close: o })))
        ])) : u("", !0)
      ]),
      trigger: n(({ open: o }) => [
        l(e.$slots, "trigger", a(t({ open: o })))
      ]),
      _: 3
    }, 8, ["backdrop-z-index", "background-color", "close-button-label", "defer", "disable-close-on-backdrop-click", "has-padding", "name", "title", "to"]));
  }
});
export {
  B as default
};
